<router-outlet></router-outlet>
<p-toast [baseZIndex]="99999"></p-toast>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
> </ngx-spinner>